module.exports = __webpack_public_path__ + "static/footer_logo-780098f1433f55f328f0377303730d9b.svg";